import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BillersService } from '../../services/billers.service'
@Component({
  selector: 'app-pay-bill',
  templateUrl: './pay-bill.component.html',
  styleUrls: ['./pay-bill.component.scss']
})
export class PayBillComponent implements OnInit {

  constructor(public router:Router,private activatedRoute: ActivatedRoute, public billerService : BillersService) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      if(!params['Approved'] && !params['payment-source-qr']){
        this.router.navigateByUrl("/pay-bill/biller1")
      }

    });
    
   
  }

}
